import { useState} from "react";
import {Rules, ValidationErrors, Validator} from "common";
import {PasswordRecoveryForm} from "./passwordRecoveryAPI";
import {useAppDispatch, useAppSelector} from "app/hooks";
import {passwordRecoveryAsync, selectIdentityStatus} from "../../../identitySlice";
export interface PasswordRecoveryFormProps {
  defaultValues?: PasswordRecoveryForm;
  token: string;
  onPasswordChanged: Function;
}

export function validatePasswordRecovery(values: PasswordRecoveryForm) {
  const rules: Rules = {
    password: Validator.rule.string().min(6).required(),
  };
  return Validator.validate(rules, values, "PasswordRecovery");
}

export default function usePasswordRecoveryForm({defaultValues, token, onPasswordChanged}: PasswordRecoveryFormProps) {
  const [item, setItem] = useState<PasswordRecoveryForm>(
    defaultValues || ({} as PasswordRecoveryForm)
  );
  const [errors, setErrors] = useState<ValidationErrors>({});
  const dispatch = useAppDispatch();
  const status = useAppSelector(selectIdentityStatus);

  function onChange(values: PasswordRecoveryForm) {
    setItem(values);
  }

  async function process() {
    const result = validatePasswordRecovery(item);
    setErrors(result.errors);

    if (!result.success) {
      return;
    }

    const response = await dispatch(passwordRecoveryAsync({item, token}));

    if (response.meta.requestStatus === "fulfilled") {
      onPasswordChanged();
    } else {
      if (response.payload) {
        setErrors({
          password: response.payload.form_errors['password'][0],
        });
      }
    }
  }

  return {
    item,
    errors,
    loading: status === "loading",
    process,
    onChange,
  };
}